import isObjectLike from "lodash/isObjectLike";
import has from "lodash/has";

export function jsonTryParse(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
    if (value === "undefined") {
      return undefined;
    }
    return value;
  }
}

export function isDraftJsState(payload) {
  return (
    payload &&
    isObjectLike(payload) &&
    has(payload, "blocks") &&
    has(payload, "entityMap")
  );
}
